module.exports = __webpack_public_path__ + "img/Mobile-Loading.2f9c2414.png";